// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"e1152ff8","641":"5128d1b7","657":"61bc5f85","721":"bdf4c575","934":"a031b9de"}[chunkId] + ".chunk.css";
};